import cx from "classnames"

interface CharacterCounterProps {
  id: string
  value?: string
  maxLength: number
  showAfter?: number
  showError?: boolean
  className?: string
}

export function CharacterCounter({
  id,
  value = "",
  maxLength,
  showAfter = 0,
  className = "",
}: CharacterCounterProps) {
  if (maxLength <= showAfter) {
    throw new Error("`maxLength` must be greater than `showAfter`")
  }

  const charCount = value.length
  const remaining = maxLength - charCount
  const shouldShowCounter = charCount >= showAfter

  return (
    <div
      className={cx(
        "fs-4 c-tint3",
        !shouldShowCounter && "visually-hidden",
        className,
      )}
    >
      <div id={id} aria-live="polite" aria-atomic="true">
        <span aria-hidden="true">
          {charCount} / {maxLength} characters
        </span>
        <span className="visually-hidden">
          {maxLength} character limit. {remaining} remaining.
        </span>
      </div>
    </div>
  )
}
